export default __webpack_public_path__ + "static/media/663.180d75af.gif";